import React, { useState } from "react";
import styles from "./EditDetails.module.css";
import HeadingAndIcon from "../../components/HeadingAndIcon/HeadingAndIcon";
import ToClose from "../../components/ToClose/ToClose";
import LogoWithName from "../../components/LogoWithName/LogoWithName";
import SaveAndCancel from "../../components/SaveAndCancel/SaveAndCancel";
import { MdDelete } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice";
import CalendarInput from "../../components/CalendarInput/CalendarInput";

const EditDetails = () => {
  const [students, setStudents] = useState([
    {
      id: 1,
      name: "John Jacob",
      date: "2025-05-30",
      checkIn: { hour: "12", minute: "44", period: "PM" },
      checkOut: { hour: "12", minute: "44", period: "PM" },
    },
  ]);

  const dispatch = useDispatch();

  const handleChange = (id, field, key, value) => {
    setStudents((prev) =>
      prev.map((student) => {
        if (student.id !== id) return student;
        if (key === null) {
          return { ...student, [field]: value }; // for date
        } else {
          return {
            ...student,
            [field]: { ...student[field], [key]: value }, // for time
          };
        }
      })
    );
  };

  const handleDelete = (id) => {
    setStudents((prev) => prev.filter((student) => student.id !== id));
  };

  const handleSave = () => {
    console.log("Saved Data:", students);
  };

  const handleCancel = () => {
    setStudents((prev) =>
      prev.map((s) => ({
        ...s,
        checkIn: { hour: "00", minute: "00", period: "AM" },
        checkOut: { hour: "00", minute: "00", period: "AM" },
      }))
    );
  };

  return (
    <div className={styles.container}>
      <div className={styles.headerBox}>
        <div className={styles.heading}>
          <HeadingAndIcon icon={<FaEdit />} heading="Edit Details" />
          <ToClose onClose={() => dispatch(closeModal())} />
        </div>
        <div className={styles.content}>
          {students.map((student) => (
            <div key={student.id} className={styles.card}>
              {/* Top row with name and calendar input */}
              <div className={styles.topRow}>
                <LogoWithName name={student.name} />
                <CalendarInput
                  value={student.date}
                  onChange={(newDate) =>
                    handleChange(student.id, "date", null, newDate)
                  }
                  label="Select Date"
                  fieldLabel=""
                  required
                />
              </div>

              {/* Data block with time and action */}
              <div className={styles.dataBlock}>
                <div className={styles.timeSection}>
                  <p>Check In Time</p>
                  <div className={styles.timeRow}>
                    <select
                      value={student.checkIn.hour}
                      onChange={(e) =>
                        handleChange(
                          student.id,
                          "checkIn",
                          "hour",
                          e.target.value
                        )
                      }
                    >
                      {Array.from({ length: 12 }, (_, i) => (
                        <option key={i}>
                          {String(i + 1).padStart(2, "0")}
                        </option>
                      ))}
                    </select>
                    <span>:</span>
                    <select
                      value={student.checkIn.minute}
                      onChange={(e) =>
                        handleChange(
                          student.id,
                          "checkIn",
                          "minute",
                          e.target.value
                        )
                      }
                    >
                      {Array.from({ length: 60 }, (_, i) => (
                        <option key={i}>{String(i).padStart(2, "0")}</option>
                      ))}
                    </select>
                    <select
                      value={student.checkIn.period}
                      onChange={(e) =>
                        handleChange(
                          student.id,
                          "checkIn",
                          "period",
                          e.target.value
                        )
                      }
                    >
                      <option value="AM">AM</option>
                      <option value="PM">PM</option>
                    </select>
                  </div>
                </div>

                <div className={styles.timeSection}>
                  <p>Check Out</p>
                  <div className={styles.timeRow}>
                    <select
                      value={student.checkOut.hour}
                      onChange={(e) =>
                        handleChange(
                          student.id,
                          "checkOut",
                          "hour",
                          e.target.value
                        )
                      }
                    >
                      {Array.from({ length: 12 }, (_, i) => (
                        <option key={i}>
                          {String(i + 1).padStart(2, "0")}
                        </option>
                      ))}
                    </select>
                    <span>:</span>
                    <select
                      value={student.checkOut.minute}
                      onChange={(e) =>
                        handleChange(
                          student.id,
                          "checkOut",
                          "minute",
                          e.target.value
                        )
                      }
                    >
                      {Array.from({ length: 60 }, (_, i) => (
                        <option key={i}>{String(i).padStart(2, "0")}</option>
                      ))}
                    </select>
                    <select
                      value={student.checkOut.period}
                      onChange={(e) =>
                        handleChange(
                          student.id,
                          "checkOut",
                          "period",
                          e.target.value
                        )
                      }
                    >
                      <option value="AM">AM</option>
                      <option value="PM">PM</option>
                    </select>
                  </div>
                </div>

                <div className={styles.actionBlock}>
                  <p>Action</p>
                  <MdDelete
                    className={styles.deleteIcon}
                    onClick={() => handleDelete(student.id)}
                  />
                </div>
              </div>
            </div>
          ))}

          <SaveAndCancel onSave={handleSave} onCancel={handleCancel} />
        </div>
      </div>
    </div>
  );
};

export default EditDetails;
